import { Skeleton } from "@/components/ui";

export const EntrySkeleton = () => {
  return (
    <div
      className="flex flex-col gap-2 rounded transition-colors mt-1"
      data-testid="meds-allergies-skeleton"
    >
      <div className="flex flex-col gap-1">
        <Skeleton className="h-10 w-full" />
      </div>
    </div>
  );
};
